import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../services/user.service';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, fromEvent, tap } from 'rxjs';
import { EditCustomerComponent } from './edit-customer/edit-customer.component';
import { MatDialog } from "@angular/material/dialog";
import { AdminToolComponent } from './admin-tool/admin-tool.component';
import { CronPopapComponent } from './cron-popap/cron-popap.component';
import { UsertransactionsComponent } from './usertransactions/usertransactions.component';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  standalone: false
})
export class CustomerComponent implements OnInit {
  displayedColumns: string[] = ['first_name', 'last_name', 'email', 'address', 'subscription_plan','last_transaction','payment_methods', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  search_customer: string = '';
  total_reports = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('search') search!: ElementRef;
  loading = false;
  processing = false;
  paymentMethods: any[] = [];
  allCustomers: any[] = [];
  @ViewChild(MatSort) sort!: MatSort;
  customerUuid: any;

  constructor(public userService: UserService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getCustomer();
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel = "Shows per page:";
    this.dataSource.paginator = this.paginator;
    fromEvent(this.search.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
        })
      )
  };

  getCustomer() {
    this.loading = true;
    this.dataSource.data = [];
    if (!this.search_customer) {
      this.userService.billingCustomer("").subscribe((response: any) => {
        if (response && Array.isArray(response.customers)) {
          console.log('All customers:', response.customers);
          this.allCustomers = response.customers;
          this.dataSource.data = response.customers;
          this.customerUuid = response.customers[0]?.user_uuid;
        } else {
          console.error("Invalid response format or no customers found:", response);
          this.dataSource.data = [];
        }
        this.loading = false;
      });
    } else {
      this.userService.billingCustomer(this.search_customer).subscribe((response: any) => {
        if (response && Array.isArray(response.customers)) {
          console.log('Search term:', this.search_customer);
          const filteredCustomers = response.customers.filter((customer: any) => {
            // console.log('Checking customer:', customer.display_name, customer.email);

            const nameMatches = customer.display_name && customer.display_name.toLowerCase().includes(this.search_customer.toLowerCase());
            const emailMatches = customer.email && customer.email.toLowerCase().includes(this.search_customer.toLowerCase());

            return nameMatches || emailMatches;
          });

          console.log('Filtered customers:', filteredCustomers);  // Log filtered data
          this.dataSource.data = filteredCustomers;
        } else {
          console.error("Invalid response format or no customers found:", response);
          this.dataSource.data = [];
        }
        this.dataSource.paginator = this.paginator;
        this.total_reports = this.dataSource.filteredData.length;
        this.loading = false;
      });
    }
  };

  editPaymentMethod(value: any) {
    this.openFieldEditorDialog(value, 'Edit Customer');


  };
  openFieldEditorDialog(value: string, title: string) {
    const dialogRef = this.dialog.open(EditCustomerComponent, {
      id: 'field-editor',
      maxWidth: '1000px',
      width: '100%',
      data: {
        title: title,
        value: value,
        customerUuid: this.customerUuid
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('Dialog closed with result:', result);
        if (result === true) {
          this.getCustomer();
        }
      },
      error: (error) => {
        console.error('Error closing dialog:', error);
      }
    })
  }


  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${month} ${day}${suffix}, ${year}`;
  }
  getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
  getAdmin(value: any) {
    console.log('getAdmin called with value:', value);
    const dialogRef = this.dialog.open(AdminToolComponent, {
      id: 'field-editor',
      maxWidth: '800px',
      width: '100%',
      data: {
        title: 'Add Listeners',
        value: value
      }
    });

    return dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getCustomer();
      }
    });
  }

  setToCronJob() {
    const dialogRef = this.dialog.open(CronPopapComponent, {
      id: 'field-editor',
      maxWidth: '600px',
      width: '100%',
    });
  }
    getPlanName(planValue: number): string {
    switch (planValue) {
      case 0: return 'Hobbyist';
      case 1: return 'Professional';
      case 2: return 'Test Based Hobbyist';
      default: return '--';
    }
  }
  getUserTransaction(element: any) {
    console.log('getUserTransaction called with element:', element);
    const dialogRef = this.dialog.open(UsertransactionsComponent, {
      id: 'field-editor',
      maxWidth: '1000px',
      width: '100%',
      data: {
        title: 'User Transactions',
        value: element
      }
    });
  }
}